<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"ASSETS"'></app-infrastructure-header>

<!-- Main Assets Component Body -->
<app-main-assets-component [displayHeader]="false"></app-main-assets-component>
